<div class="mosaic-wrapper irx-sobre-oscuro">
  <!-- Toolbar -->
  <div class="mosaic-toolbar">
    <!-- Volver -->
    <button
      irxBotonIcono
      tamano="compacto"
      class="back-btn"
      tooltip="Volver"
      (click)="back.emit()"
    >
      <span class="material-icons">arrow_back</span>
    </button>

    <div class="toolbar-divider"></div>

    <!-- Selector de tamaño de grilla -->
    <irx-segmentado
      tamano="compacto"
      aria-label="Cámaras por pantalla"
      [value]="gridSize"
      (change)="setGridSize($event.value)"
    >
      @for (size of gridSizes; track size) {
        <irx-segmento [value]="size">{{ size }}</irx-segmento>
      }
    </irx-segmentado>

    <div class="toolbar-divider"></div>

    <!-- Selector de ratio de slot -->
    <irx-segmentado
      tamano="compacto"
      aria-label="Proporción"
      [value]="slotRatio"
      (change)="slotRatio = $event.value"
    >
      <irx-segmento value="16/9">16:9</irx-segmento>
      <irx-segmento value="4/3">4:3</irx-segmento>
    </irx-segmentado>

    <!-- Selector rápido de cámara (solo en modo 1 cámara) -->
    @if (gridSize === 1 && streams.length > 1) {
      <div class="toolbar-divider"></div>
      <button
        irxBotonIcono
        tamano="compacto"
        alternable
        [activo]="showCameraList"
        (click)="showCameraList = !showCameraList"
        tooltip="Seleccionar cámara (también con ← → o 1-9)"
      >
        <span class="material-icons">video_camera_back</span>
      </button>
    }

    <!-- Info de la cámara seleccionada (mosaico 4/9/16) -->
    @if (gridSize > 1 && selectedStream; as sel) {
      <div class="toolbar-divider"></div>
      <div class="selection-info">
        <span class="material-icons selection-icon">videocam</span>
        <span class="selection-nombre">
          {{ sel.camara.identificacion || 'Cámara sin nombre' }}
        </span>
        <span class="selection-detalle">{{ selectedDetalle }}</span>
      </div>
      <button
        irxBoton="tonal"
        tamano="compacto"
        (click)="viewSingle()"
        tooltip="Ver esta cámara sola (doble clic en la cámara)"
      >
        <span class="material-icons">fullscreen</span>
        Ver sola
      </button>
      <button
        irxBotonIcono
        tamano="compacto"
        (click)="clearSelection()"
        tooltip="Quitar selección"
      >
        <span class="material-icons">close</span>
      </button>
    }

    <!-- Paginación (solo si hay más de una página) -->
    @if (totalPages > 1) {
      <div class="toolbar-divider"></div>
      <div class="pagination">
        <button
          irxBotonIcono
          tamano="compacto"
          tooltip="Página anterior"
          [disabled]="isFirstPage"
          (click)="prevPage()"
        >
          <span class="material-icons">chevron_left</span>
        </button>
        <span class="page-info">{{ currentPage + 1 }} / {{ totalPages }}</span>
        <button
          irxBotonIcono
          tamano="compacto"
          tooltip="Página siguiente"
          [disabled]="isLastPage"
          (click)="nextPage()"
        >
          <span class="material-icons">chevron_right</span>
        </button>
      </div>
    }
  </div>

  <!-- Barra de grabación (solo en modo 1 cámara) -->
  @if (gridSize === 1) {
    <div class="record-toolbar">
      <!-- Indicador de modo -->
      @if (isRecordingMode) {
        <span class="mode-badge recording">
          <span class="material-icons">history</span>
          Grabación
        </span>
      } @else {
        <span class="mode-badge live">
          <span class="material-icons">radio_button_checked</span>
          En vivo
        </span>
      }

      <div class="record-sep"></div>

      @if (fechaEvento) {
        <!-- Rebobinados desde la hora del evento -->
        @for (r of rebobinados; track r.min) {
          <button
            irxBoton="secundario"
            tamano="compacto"
            (click)="volverAtras(r.min)"
            [tooltip]="'Ver grabación desde ' + r.label + ' antes del evento'"
          >
            <span class="material-icons">fast_rewind</span>
            {{ r.label }}
          </button>
        }
        <button
          irxBoton="secundario"
          tamano="compacto"
          (click)="volverAtras(0)"
          tooltip="Ver grabación desde la hora del evento"
        >
          <span class="material-icons">schedule</span>
          Hora del evento
        </button>
      } @else {
        <!-- Selector de fecha/hora -->
        <input
          #dateInput
          type="datetime-local"
          class="record-date-input"
          [value]="selectedDate"
          [max]="maxDate"
          (change)="selectedDate = dateInput.value"
        />

        <!-- Ver grabación -->
        <button
          irxBoton="principal"
          tamano="compacto"
          [disabled]="!selectedDate"
          (click)="watchRecording()"
          tooltip="Ver grabación en esta fecha"
        >
          <span class="material-icons">play_circle</span>
          Ver
        </button>
      }

      <!-- Volver a vivo (solo visible si estás en grabación) -->
      @if (isRecordingMode) {
        <button
          irxBoton="tonal"
          tamano="compacto"
          (click)="goLive()"
          tooltip="Volver a stream en vivo"
        >
          <span class="material-icons">live_tv</span>
          En vivo
        </button>
      }
    </div>
  }

  <!-- Lista de cámaras para salto rápido (overlay sobre el grid) -->
  @if (showCameraList && gridSize === 1) {
    <div class="camera-list-overlay" (click)="showCameraList = false">
      <div class="camera-list-panel" (click)="$event.stopPropagation()">
        @for (
          stream of streams;
          track stream.camara._id + '_' + stream.canal;
          let i = $index
        ) {
          <button
            type="button"
            class="irx-sin-estilo camera-list-item"
            [class.active]="i === currentPage"
            [attr.aria-pressed]="i === currentPage"
            (click)="goToCamera(i)"
          >
            <span class="camera-list-num">{{ i + 1 }}</span>
            <span class="camera-list-name">
              {{ stream.camara.identificacion }}
            </span>
          </button>
        }
      </div>
    </div>
  }

  <!-- Área que centra el grid y absorbe el espacio restante -->
  <div class="mosaic-grid-area">
    <!-- Sin ocultar la grilla al cambiar de layout/página: el track por
         cámara+canal conserva los players que siguen visibles y sus
         sesiones RTSP no se cortan. -->
    <div
      class="mosaic-grid"
      [class]="'cols-' + cols"
      [style.aspect-ratio]="slotRatio"
      [style.grid-template-rows]="'repeat(' + rows + ', 1fr)'"
    >
      @for (
        slot of currentSlots;
        track slot ? slot.camara._id + '_' + slot.canal : 'empty_' + $index
      ) {
        @if (slot) {
          <div
            class="mosaic-slot"
            [class.irx-clickeable]="gridSize > 1"
            [attr.role]="gridSize > 1 ? 'button' : null"
            [attr.tabindex]="gridSize > 1 ? 0 : null"
            [class.selected]="gridSize > 1 && selectedKey === streamKey(slot)"
            (click)="gridSize > 1 && toggleSelect(slot)"
            (keydown.enter)="gridSize > 1 && toggleSelect(slot)"
            (dblclick)="gridSize > 1 && viewSingle(slot)"
          >
            <!-- Main solo en vista de 1 cámara; en mosaico 4/9/16, sub-stream. -->
            <app-mosaic-video
              [stream]="slot"
              [mainStream]="gridSize === 1"
            ></app-mosaic-video>
          </div>
        } @else {
          <div class="mosaic-slot mosaic-slot-empty">
            <img
              class="empty-logo"
              src="assets/images/irix_logo_dark.png"
              alt=""
              draggable="false"
            />
          </div>
        }
      }
    </div>

    <!-- Flechas para pasar de cámara en la vista de 1 cámara -->
    @if (gridSize === 1 && streams.length > 1) {
      @if (!isFirstPage) {
        <button
          irxBotonIcono="imagen"
          tamano="campo"
          class="nav-arrow nav-arrow--prev"
          (click)="prevPage()"
          tooltip="Cámara anterior (←)"
        >
          <span class="material-icons">chevron_left</span>
        </button>
      }
      @if (!isLastPage) {
        <button
          irxBotonIcono="imagen"
          tamano="campo"
          class="nav-arrow nav-arrow--next"
          (click)="nextPage()"
          tooltip="Cámara siguiente (→)"
        >
          <span class="material-icons">chevron_right</span>
        </button>
      }
    }
  </div>
</div>
